class HelperService {
	capitalize(str) {
		if (str) {
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
		return "";
	}

	handleMoneyFormat(number, fraction, showCurrency, currency) {
		if (number === null || number === undefined) {
			return;
		}

		const validCurrency = !currency ? "NGN" : currency;

		const trimmedCurrency = validCurrency?.slice(0, -1);
		const locale = `en-${trimmedCurrency}`;

		const options = {
			minimumFractionDigits: fraction,
			style: showCurrency ? "currency" : undefined,
			currency: showCurrency ? validCurrency : undefined,
		};

		if (number >= 1000000) {
			options.notation = "compact";
		}

		return new Intl.NumberFormat(locale, options).format(number);
	}

	formatNumber(num, decimal = 0) {
		if (num === undefined || num === null) {
			return 0;
		}

		return Intl.NumberFormat("en-US", {
			style: "decimal",
			maximumFractionDigits: decimal,
			minimumFractionDigits: decimal,
		}).format(num);
	}

	convertArrayToCSV(data, schema) {
		if (!data.length) return "";

		const headerRow = schema.map((col) => `"${col.label}"`).join(",");

		const dataRows = data.map((item) =>
			schema
				.map((col) => {
					const raw = item[col.key];
					const formatted =
						typeof col.formatter === "function"
							? col.formatter(raw)
							: (raw ?? "");
					const escaped = String(formatted).replace(/"/g, '""');
					return `"${escaped}"`;
				})
				.join(",")
		);
		return [headerRow, ...dataRows].join("\r\n");
	}

	cleanAmounts(value) {
		if (!value) {
			return;
		}

		const cleanedValue = value?.replace(/[^0-9.]/g, "");
		return cleanedValue;
	}
}

export default new HelperService();
